import { combineReducers } from 'redux';

import assets from './assets';
import domains from './domains';
import incidents from './incidentStatus';
import links from './linkStatus';
import nonEnforcementReasons from './nonEnforcementReasons';
import protectionTypes from './protectionTypes';
import values from './values';

const filters = {
  assets,
  domains,
  incidents,
  links,
  nonEnforcementReasons,
  protectionTypes,
  values,
};

export default combineReducers(filters);

export const getAllIncidentsFilters = state => state.values;
